import { CampaignType_Enum as CampaignType, Segment } from '@weave/schema-gen-ts/dist/schemas/messaging/bulk/v2';
import type { UpsertAudience } from '@frontend/api-bulk-messaging';
import { theme } from '@frontend/theme';
import { ModalControlModalProps, Tray } from '@frontend/design-system';
import { AudienceTrayFooter } from './audience-tray-footer';
import { AudienceTrayHeader } from './audience-tray-header';
import { AudienceTrayLoader } from './audience-tray-loader';
import { AudienceTraySharedFooter } from './audience-tray-shared-footer';

type Props = ModalControlModalProps & {
  campaignId: string;
  campaignType: CampaignType;
  deleteSegments: (segments: Segment[]) => void;
  isUpsertingAudience: boolean;
  locationIds: string[];
  upsertAudience: UpsertAudience;
};

// TODO: Add a read-only mode where the user can only view the audience and not edit it
export const AudienceTray = ({
  campaignId,
  campaignType,
  deleteSegments,
  upsertAudience,
  isUpsertingAudience,
  locationIds,
  onClose,
  show,
}: Props) => {
  return (
    <Tray
      disableCloseOnEscape
      onClose={onClose}
      show={show}
      width='large'
      css={{
        padding: theme.spacing(4, 0),
        gap: 'unset',
        '.tray-header': {
          alignItems: 'start',
          padding: theme.spacing(0, 4),
        },
      }}
    >
      <AudienceTrayLoader
        campaignId={campaignId}
        campaignType={campaignType}
        closeTray={onClose}
        deleteSegments={deleteSegments}
        isUpsertingAudience={isUpsertingAudience}
        locationIds={locationIds}
        upsertAudience={upsertAudience}
      />
    </Tray>
  );
};

AudienceTray.Footer = AudienceTrayFooter;
AudienceTray.Header = AudienceTrayHeader;
AudienceTray.SharedFooter = AudienceTraySharedFooter;
